<template>
  <div id="app">
    <ion-app>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </ion-app>
  </div>
</template>
